module.exports = __webpack_public_path__ + "static/media/book-user.81f1dcdd.svg";